import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { InvestmentPerspective } from "@/components/perspective/InvestmentPerspective";
import { PropertyCard } from "@/components/PropertyCard";
import { PropertySearch } from "@/components/PropertySearch";
import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/seed";

export default function Invests() {
  const { data } = useApp();
  const properties = data.properties.filter((p) => p.published && p.category.includes("invests")).slice(0, 6);

  return (
    <div>
      <section className="relative min-h-[80vh] overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.comm1} alt="Invests" className="h-full w-full object-cover" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(5,15,12,0.94), rgba(5,15,12,0.72))" }} />
        </div>
        <div className="hero-copy container-arch relative flex min-h-[80vh] flex-col justify-center pt-24">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-2xl">
            <div className="overline !text-[#9ED3B8]">Archedia Invests · For the value you want to build</div>
            <h1 className="mt-4 font-serif text-4xl font-light leading-[1.1] text-white sm:text-5xl lg:text-6xl">Buy Real Estate With an Investment Perspective.</h1>
            <p className="mt-5 max-w-lg text-white/70">Entry, micro-market, demand and exit — evaluated as one connected picture.</p>
            <Link to="/request?purpose=Investment" className="btn-gold mt-8 !bg-[var(--accent-gold)] !text-[#071711]">Explore Investment Opportunities <ArrowUpRight className="h-4 w-4" /></Link>
          </motion.div>
        </div>
      </section>

      <section className="container-arch relative z-20 -mt-8" data-testid="vertical-search">
        <div className="arch-card p-3 sm:p-4"><PropertySearch /></div>
      </section>

      <section className="container-arch py-20 lg:py-28">
        <Reveal><div className="overline">The Investment Perspective</div>
          <h2 className="mt-3 max-w-2xl font-serif text-3xl font-light text-[var(--text-primary)] sm:text-4xl">Market → Micro-Market → Developer → Project → Entry → Demand → Exit</h2>
        </Reveal>
        <div className="mt-14"><InvestmentPerspective /></div>
      </section>

      <section className="border-t border-[var(--border-subtle)] py-20 lg:py-28">
        <div className="container-arch">
          <Reveal><div className="overline">Investment opportunities</div><h2 className="mt-3 font-serif text-3xl font-light text-[var(--text-primary)] sm:text-4xl">Assets worth a closer perspective</h2></Reveal>
          <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {properties.map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
          </div>
        </div>
      </section>
    </div>
  );
}
